<template>
	<a-config-provider :locale="locale">
		<div id="app">
			<a-layout id="layout">
				<ws-header />
				<div class="contents"><router-view /></div>
				<ws-footer />
			</a-layout>
		</div>
	</a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import WsHeader from './components/WsHeader';
import WsFooter from './components/WsFooter';
export default {
	components: {
		WsHeader,
		WsFooter
	},
	data() {
		return {
			// locale: enUS
		};
	},
	computed: {
		locale() {
			const lang = {
				'zh-CN': zhCN,
				'en-US': enUS
			};
			return lang[this.$store.state.language];
		}
	},
	mounted() {
		var time = null;
		document.addEventListener('visibilitychange', () => {
			if (document.hidden) {
				time = Date.now();
			} else if (time) {
				const interval = Date.now() - time;
				if (interval > 30 * 60 * 1000) {
					location.reload();
				} else if (interval > 5 * 60 * 1000) {
					this.$bus.$emit('refresh');
				}
			}
		});
	}
};
</script>
<style lang="less">
html,
body {
	height: 100%;
	background-color: #ffffff;
	// user-select: none;
}

#app {
	min-height: 100%;
	font-family: Avenir, Helvetica, Arial, sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue',
		Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}

input,
textarea {
	user-select: auto;
}

#layout {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}

.contents {
	padding: 20px 50px;
	flex: 1;
}

img {
	max-width: 100%;
}

.ant-space-vertical {
	width: 100%;
}

.ant-card-body > .ant-table-wrapper {
	border-top: 1px solid #e8e8e8;
}

.ant-table-wrapper .ant-pagination {
	padding-left: 24px;
	padding-right: 24px;
}
</style>
